export default "__VITE_ASSET__BYSDIjpf__"